<div class="main-content div__main">
  <div class="container-fluid p-0">
    <div class="row justify-content-center">
      <div
        class="col-4 col-md-2"
        *ngFor="let card of resumenCardsTwo; index as i"
      >
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 1 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
                >
                  <!-- {{ card.value }} -->
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 3 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 3, 'text-white': i !== 3 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 3 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools">
          <a [routerLink]="['/numbers/accounting']" class="btn btn-dark btn-sm btn-new">
            Staff
          </a>
          <a
            [routerLink]="['/numbers/accounting/freelancers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Freelancers
          </a>
          <a
            [routerLink]="['/numbers/accounting/drivers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Driver & +
          </a>
          <a
            [routerLink]="['/numbers/accounting/customers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Customers
          </a>
        </div>
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              {{ id ? "Update" : "New" }} Payment
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="description"
                      >Description</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="description"
                      formControlName="description"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('description')"
                    >
                      Description is required
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="dueDate"
                      >Due Date</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="dueDate"
                      formControlName="dueDate"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('dueDate')"
                    >
                      Due Date is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="value">Cost</label>
                    <input
                      type="number"
                      class="form-control"
                      id="value"
                      formControlName="value"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('value')"
                    >
                      Value is required
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="frequency"
                      >Frequency</label
                    >
                    <select
                      class="form-control select"
                      id="frequency"
                      formControlName="frequency"
                      [ngClass]="{ disabled__select: !update }"
                    >
                      <option value="" disabled>Select a frequency</option>
                      <option
                        *ngFor="let item of frequencies"
                        [value]="item.code"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('frequency')"
                    >
                      Frequency is required
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row" *ngIf="internal">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="personnel"
                      >Personnel</label
                    >
                    <select
                      class="form-control"
                      id="personnel"
                      formControlName="personnel"
                    >
                      <option value="">Select a personnel</option>
                      <option *ngFor="let item of personnel" [value]="item._id">
                        {{ item.firstname }} {{ item.lastname }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('personnel')"
                    >
                      Personnel is required
                    </div>
                  </div>
                </div>
              </div> -->

              <button
                type="submit"
                class="btn btn-dark pull-right btn-create"
                [disabled]="form.invalid"
              >
                {{ id ? "Update" : "Create" }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
          <div class="card card-profile">
            <div class="card-avatar"></div>
            <div class="card-body">
              <h6 class="card-category text-gray">Perfil de usuario</h6>
              <h4 class="card-title">
                {{ form.get("firstname")?.value }}
                {{ form.get("lastname")?.value }}
              </h4>
              <p class="card-description">
                Aquí puedes editar los datos del usuario. Los cambios se
                reflejarán en el sistema.
              </p>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</div>
